import { Col, Form, Input, InputNumber, Row } from 'antd'
import useFetch from 'elements/Hooks/useFetch'
import CustomSpin from '../elements/CustomSpin'
import FormSectionTitle from '../elements/FormSectionTitle'
import useFetchURL from '../elements/Hooks/useFetchURL'
import CurrencySelect from '../elements/Select/Currency'
import { get, isEmpty, round } from 'lodash'
import { rules, threeFormItemLayout } from '../modules/FormItems'
import moment from 'moment'
import React, { Fragment, useEffect } from 'react'
import fx from 'money'

function MultiCurrency(props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue, date, doc, type, title } = props

  const attributesMap = {
    purchase: {
      currency: 'currency',
      reportingCurrency: 'reportingCurrency',
      exchangeRate: 'exchange.rate',
      companyId: 'company._id',
    },
    vendorQuote: {
      currency: 'currency',
      reportingCurrency: 'reportingCurrency',
      exchangeRate: 'exchange.rate',
      companyId: 'company._id',
    },
    remittance: {
      currency: 'from.currency',
      reportingCurrency: 'reportingCurrency',
      exchangeRate: 'exchange.rate',
      companyId: 'from.payor._id',
    },
    quote: {
      currency: 'currency',
      reportingCurrency: 'reportingCurrency',
      exchangeRate: 'exchange.rate',
      companyId: 'company._id',
    },
    sales: {
      currency: 'cpo.currency',
      reportingCurrency: 'reportingCurrency',
      exchangeRate: 'exchange.rate',
      companyId: 'company._id',
    },

    enquiry: {
      currency: 'cpo.currency',
      reportingCurrency: 'reportingCurrency',
      exchangeRate: 'exchange.rate',
      companyId: 'company._id',
    },
    invoice: {
      currency: 'otherPayment.currency',
      reportingCurrency: 'reportingCurrency',
      exchangeRate: 'exchange.rate',
      companyId: 'company._id',
    },
    receipt: {
      currency: 'currency',
      reportingCurrency: 'reportingCurrency',
      exchangeRate: 'exchange.rate',
      companyId: 'company._id',
    },
  }

  const attrMap = attributesMap[type]
  const currency = getFieldValue(attrMap.currency)

  let companyID = (getFieldValue(attrMap.companyId) || get(doc, attrMap.companyId) || '').replace('members/', '')
  const { data: company, fetching: fetchingMember } = useFetch({
    url: `members/${companyID}`,
    dependencyArray: [companyID],
    dontFetch: isEmpty(companyID),
  })

  const corporatePartner = get(company, 'partner', []).find((r) => r.type === 'corporate')
  //console.log({corporatePartner})
  const reportingCurrency = get(corporatePartner, 'reportingCurrency')
  const reportCurrency = getFieldValue(attrMap.reportingCurrency) || reportingCurrency

  const { data: exchange, fetching } = useFetch({
    url: `exchange${date ? moment(date).format('YYYY-MM-DD') : ''}`,
    dependencyArray: [currency, reportCurrency],
    dontFetch: isEmpty(currency) || isEmpty(reportCurrency),
  })

  useEffect(() => {
    if (!!reportingCurrency) {
      setFieldsValue({ [attrMap.reportingCurrency]: reportingCurrency })
    }
  }, [companyID, fetchingMember])

  useEffect(() => {
    if (currency === reportCurrency) {
      setFieldsValue({ [attrMap.exchangeRate]: 1 })
    } else if (!isEmpty(exchange) && !isEmpty(company)) {
      fx.rates = exchange.rates
      fx.base = exchange.base
      console.log({
        from: currency,
        to: reportCurrency,
      })
      let rate = 0
      try {
        rate = fx.convert(1, {
          from: currency,
          to: reportCurrency,
        })
      } catch (e) {}
      setFieldsValue({ [attrMap.exchangeRate]: round(rate, 3) || rate })
    }
  }, [currency, reportCurrency, fetching, companyID, reportingCurrency])

  return (
    <Fragment>
      {title && <FormSectionTitle title={title} />}
      <Row>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="Currency">
            {getFieldDecorator(attrMap.currency, {
              initialValue: get(doc, attrMap.currency),
              rules: rules.select,
            })(<CurrencySelect style={{ width: '80%' }} />)}
          </Form.Item>
        </Col>

        <Col span={8}>
          <CustomSpin spinning={fetchingMember}>
            <Form.Item {...threeFormItemLayout} label="Reporting Currency">
              {getFieldDecorator(attrMap.reportingCurrency, {
                initialValue: get(doc, attrMap.reportingCurrency) || reportingCurrency,
                // rules: rules.select,
              })(<CurrencySelect disabled={true} />)}
            </Form.Item>
          </CustomSpin>
        </Col>

        {getFieldValue(attrMap.reportingCurrency) && (
          <Col span={8}>
            <CustomSpin spinning={fetching}>
              <Form.Item {...threeFormItemLayout} label="Exchange Rate">
                {getFieldDecorator(attrMap.exchangeRate, {
                  initialValue: get(doc, attrMap.exchangeRate),
                  rules: rules.select,
                })(<Input addonBefore={reportCurrency} style={{ width: '80%' }} disabled={true} />)}
              </Form.Item>
            </CustomSpin>
          </Col>
        )}
      </Row>
    </Fragment>
  )
}

export default MultiCurrency
